export default __webpack_public_path__ + "static/media/IconUserManagementActive.4016cdfc.svg";